import React from 'react';
import { formatPatientName } from '../../services/api/abhaProfile';

/** "UHID/000002" already carries its prefix; bare ids get one. */
export function formatUhid(uhid) {
  if (!uhid) return '';
  return /^uhid/i.test(String(uhid)) ? String(uhid) : `UHID ${uhid}`;
}

/** Line 1: patient name + UHID (+ IP number). Missing fields render nothing. */
export function rowTitle({ name, uhid, ipNumber }) {
  const parts = [formatPatientName({ first_name: name }) || 'Patient'];
  if (uhid) parts.push(formatUhid(uhid));
  if (ipNumber) parts.push(`IP ${ipNumber}`);
  return parts.join('  ·  ');
}

/** Joins the present parts with " · ". */
export function joinParts(parts) {
  return parts.filter((p) => p !== null && p !== undefined && p !== '').join(' · ');
}

/** Line 3 — what will be sent. `ok` false renders amber (needs attention); `text` null renders nothing. */
export function SendContentLine({ text, ok, isDark }) {
  if (!text) return null;
  const color = ok ? (isDark ? '#4ade80' : '#15803d') : (isDark ? '#fbbf24' : '#b45309');
  return <p style={{ margin: '2px 0 0', fontSize: 12, fontWeight: 600, color }}>{text}</p>;
}
